import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = ["emailType", "dayOfWeek", "dayOfMonth", "emailRecipients", "brand"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const emailType = this.emailTypeTarget.value
    switch(emailType) {
      case "daily":
        showTarget(this.emailRecipientsTarget)
        hideTarget(this.dayOfWeekTarget)
        hideTarget(this.dayOfMonthTarget)
        if(this.hasBrandTarget) {
          showTarget(this.brandTarget)
        }
        break
      case "weekly":
        showTarget(this.emailRecipientsTarget)
        showTarget(this.dayOfWeekTarget)
        hideTarget(this.dayOfMonthTarget)
        if(this.hasBrandTarget) {
          showTarget(this.brandTarget)
        }
        break
      case "monthly":
        showTarget(this.emailRecipientsTarget)
        hideTarget(this.dayOfWeekTarget)
        showTarget(this.dayOfMonthTarget)
        if(this.hasBrandTarget) {
          showTarget(this.brandTarget)
        }
        break
      default:
        hideTarget(this.emailRecipientsTarget)
        hideTarget(this.dayOfWeekTarget)
        hideTarget(this.dayOfMonthTarget)
        if(this.hasBrandTarget) {
          hideTarget(this.brandTarget)
        }
    }
  }
}

